import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/app/profile')({
  component: lazyRouteComponent(() => import('./-profile')),
})
